import Controller from './lib/controller';

import SystemAnimation from './system/system-animation';
import SystemVideo from './system/system-video';
import SiteHeader from './site/site-header';
import SiteMobileMenu from './site/site-mobile-menu';
import SiteSearch from './site/site-search';

import './plugins/complianz';

import BlockTextImageCarousel from './blocks/block-text-image-carousel';
import BlockTaxonomyTerm from './blocks/block-taxonomy-term';
import BlockProductGallery from './blocks/block-product-gallery';
import BlockProductTabs from './blocks/block-product-tabs';
import BlockCookie from './blocks/block-cookie';
import BlockPartsSearch from './blocks/block-parts-search';

const controller = new Controller({
  'SystemAnimation': SystemAnimation,
  'SystemVideo': SystemVideo,

  'SiteHeader': SiteHeader,
  'SiteMobileMenu': SiteMobileMenu,
  'SiteSearch': SiteSearch,

  'BlockTextImageCarousel': BlockTextImageCarousel,
  'BlockTaxonomyTerm': BlockTaxonomyTerm,
  'BlockProductGallery': BlockProductGallery,
  'BlockProductTabs': BlockProductTabs,
  'BlockCookie': BlockCookie,
  'BlockPartsSearch': BlockPartsSearch,
});

controller.findControllers({
  parent: document,
});

// controller.init('SystemAnimation', document);
